import { skipToken } from '@reduxjs/toolkit/query/react'
import { useFetchUserStatusQuery } from '@/api/user-api'
import { useFetchAvailableUnlockDataQuery } from '@/api/workspaces-api'
import useKolInfoContext from '@/components/kol/hooks/use-kol-info-context'
import { usePermissions } from '@/hooks/use-permissions'
import type { FetchAvailableUnlockDataResponse } from '@/types/schema/kol/unlock'
import isQuotaBasedWorkspaceType from '@/utils/workspace/is-quota-based-workspace-type'

type UseAvailableUnlockData = (kolId?: string) => {
  availableUnlockData: FetchAvailableUnlockDataResponse | undefined
  isSuccess: boolean
}

const useAvailableUnlockData: UseAvailableUnlockData = (kolId) => {
  const kolInfoContext = useKolInfoContext()
  const { withKolPermission } = usePermissions()
  const { data: userStatus } = useFetchUserStatusQuery(
    withKolPermission || kolInfoContext?.info ? skipToken : undefined,
  )

  const workspaceType = userStatus?.currentWorkspace?.workspaceType
  const isQuotaBasedWorkspace = workspaceType
    ? isQuotaBasedWorkspaceType(workspaceType)
    : false
  const { data: availableUnlockData, isSuccess } =
    useFetchAvailableUnlockDataQuery(
      kolId && isQuotaBasedWorkspace
        ? {
            kolId,
          }
        : skipToken,
    )

  return { availableUnlockData, isSuccess }
}

export default useAvailableUnlockData
